module.exports = __webpack_public_path__ + "static/img/zhongoujingjia.207a08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/zhongoujingjia.png
// module id = Kb4q
// module chunks = 44